import React from 'react';
import { FormattedMessage } from 'react-intl';

import Autocomplete from 'components/form/autocomplete';
import { Field } from 'formik';
import { requirementTypeOPTs } from 'enums/formOtps';

export const initialValues = {
  data: {
    glass: '',
    Checklist: '',
  },
};

export const Application = () => (
  <>
    <div className="row FormRow">
      <div className="col-sm-12 col-md-12 col-lg-4">
        <FormattedMessage id="Necesidad Principal: *" />
      </div>
      <div className="col-sm-12 col-md-12 col-lg-8">
        <Field
          name="data.need"
          selec
          component={Autocomplete}
          variant="outlined"
          options={requirementTypeOPTs}
        />
      </div>
    </div>
    {/*<div className="row FormRow">
      <div className="col-sm-12 col-md-12 col-lg-4">
        <FormattedMessage id="Realizó el Glass Checklist: *" />
      </div>
      <div className="col-sm-12 col-md-12 col-lg-8">
        <Field
          name="data.Checklist"
          component={Autocomplete}
          variant="outlined"
          options={checkListTypeOPTs}
        />
      </div>
</div>*/}
    <div className="col-12">
      <div className="kt-space-20" />
    </div>
  </>
);

export default Application;
